<template>
    <div>
        <div>
            <div class="flex flex-wrap gap-x-2 gap-y-1 items-center" @click="showSlideOver = true">
                <BadgePill v-for="option in selectedOptions" :key="option.value" class="cursor-pointer">
                    {{ option.text }}
                </BadgePill>
                <template v-if="selectedOptions.length === 0">
                    <AppButton element="button" type="button">
                        {{ $t('messages.select') }}
                    </AppButton>
                </template>
                <button type="button">
                    <svg
                        class="w-10 h-10 text-indigo-300"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z"
                            clip-rule="evenodd"
                        ></path>
                    </svg>
                </button>
            </div>
        </div>
        <SlideOver :show="showSlideOver" @close="showSlideOver = false">
            <div>
                <SelectAllNoneButtons
                    :max-count="options.length"
                    :selected-count="selected.length"
                    @select-all="selectAll()"
                    @select-none="deselectAll()"
                    class="flex"
                />
            </div>
            <ul>
                <li v-for="option in options" :key="option.value">
                    <label class="ml-1 mr-3">
                        <input
                            name="options[]"
                            type="checkbox"
                            :value="option.value"
                            v-model.number="selected"
                            class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded mr-1"
                        />
                        <span class="inline-block text-sm leading-5 font-medium text-gray-700">
                            {{ option.text }}
                        </span>
                    </label>
                </li>
            </ul>
            <div>
                <slot />
            </div>
        </SlideOver>
    </div>
</template>

<script>
import SlideOver from '@/components/SlideOver.vue';
import BadgePill from '@/components/BadgePill.vue';
import AppButton from '@/components/AppButton.vue';
import SelectAllNoneButtons from '@/components/SelectAllNoneButtons.vue';

export default {
    name: 'SlideOverCheckboxInput',
    components: {
        SlideOver,
        BadgePill,
        AppButton,
        SelectAllNoneButtons,
    },
};
</script>
<script setup>
import { useVModel } from '@vueuse/core';
import { computed, ref } from 'vue';

const props = defineProps({
    modelValue: {
        required: true,
    },
    options: {
        required: true,
        type: Array,
    },
    intKeys: {
        required: false,
        type: Boolean,
        default: true,
    },
});
let emit = defineEmits(['update:modelValue']);
const selected = useVModel(props, 'modelValue', emit);

const selectedIds = computed(() => {
    if (props.intKeys) {
        return selected.value.map((s) => +s);
    }

    return selected.value;
});

const selectedOptions = computed(() => {
    return props.options.filter((s) => selectedIds.value.includes(s.value));
});

const selectAll = () => {
    selected.value = props.options.map((o) => o.value);
};
const deselectAll = () => {
    selected.value = [];
};

const showSlideOver = ref(false);
</script>
